import { TranslationKey } from './../../../types/translation/TranslationKey';

import React from 'react';
import { t } from '../../../types/translation/Translator';
import Pane from '../../../VentoryUI/components/common/Pane';
import { Route, Routes } from 'react-router-dom';
import AssetDetailPane from './Panes/AssetDetailPane';
import AssetDetailHistoryPane from './Panes/AssetDetailHistoryPane';

const tabs = () => [
  {
    text: t(TranslationKey.asset).singular.label,
    path: 'stock',
    key: 'stock',
  },
  {
    text: t(TranslationKey.history).singular.label,
    path: 'history',
    key: 'history',
  },
];

export default function AssetInfoScreen() {
  return (
    <Pane tabs={tabs()}>
      <Routes>
        <Route path='stock' element={<AssetDetailPane />} />
        <Route path='history' element={<AssetDetailHistoryPane />} />
      </Routes>
    </Pane>
  );
}
